import { APP_INITIALIZER, enableProdMode, importProvidersFrom, isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { apiUrlInterceptor } from './app/interceptors/api-url.interceptor';
import { authInterceptor } from './app/interceptors/auth.interceptor';
import { indicatorInterceptor, responseInterceptor, SettingsService } from 'library-explorer';
import { AuthenticationService } from './app/services/authentication.service';
import { initializeAppFactory } from './app/factories/initialize.factory';
import { Angular4PaystackModule } from 'angular4-paystack';
import { httpXsrfInterceptor } from './app/interceptors/http-csrf.interceptor';
import { UtilitiesService } from './app/services/utilities.service';
import { InterResponseHandlerInterceptor } from './app/interceptors/internal-response-handler.interceptor';
import { provideServiceWorker } from '@angular/service-worker';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy, },
    importProvidersFrom(
      Angular4PaystackModule.forRoot('pk_test_xxxxxxxxxxxxxxxxxxxxxxxx')
    ),
    provideIonicAngular({
      mode: 'md'
    }),
    provideRouter(routes),
    provideHttpClient(
      // registering interceptors
      withInterceptors([apiUrlInterceptor, authInterceptor, indicatorInterceptor, httpXsrfInterceptor, responseInterceptor, InterResponseHandlerInterceptor])
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppFactory,
      deps: [AuthenticationService, UtilitiesService, SettingsService],
      multi: true
    }, provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000'
          }),
  ],
},);
